import React, { useState, useEffect } from 'react';
import { serviceRequestService } from '../../../services/serviceRequestService';

const ManageServiceRequests = () => {
    const [requests, setRequests] = useState([]);

    useEffect(() => {
        fetchRequests();
    }, []);

    const fetchRequests = async () => {
        try {
            const data = await serviceRequestService.getAllRequests();
            setRequests(data);
        } catch (error) {
            console.error("Failed to fetch requests", error);
        }
    };

    const handleApprove = async (id) => {
        try {
            await serviceRequestService.updateRequestStatus(id);
            fetchRequests(); // refresh list
        } catch(err) {
            console.error("Failed to approve", err);
        }
    };

    const handleDelete = async (id) => {
        if (window.confirm("Are you sure you want to delete this request?")) {
            try {
                await serviceRequestService.deleteRequest(id);
                fetchRequests();
            } catch(err) {
                console.error("Failed to delete", err);
            }
        }
    };

    return (
        <div className="py-24 bg-slate-50 min-h-screen mt-16 px-6 sm:px-8 lg:px-10">
            <div className="max-w-7xl mx-auto">
                <div className="text-center mb-16">
                    <h2 className="text-4xl md:text-5xl font-black text-slate-900 tracking-tight lowercase">Manage <span className="text-amber-500">Service Requests</span></h2>
                    <div className="w-24 h-2 bg-amber-500 mx-auto mt-6 rounded-full shadow-lg shadow-amber-500/20"></div>
                </div>
                
                <div className="bg-white shadow-2xl rounded-[2.5rem] overflow-hidden border border-slate-100">
                    {requests.length === 0 ? (
                        <div className="py-24 text-center text-slate-400 font-medium italic">No service requests found. Still waiting for travelers.</div>
                    ) : (
                        <div className="overflow-x-auto scrollbar-hide">
                            <table className="min-w-full divide-y divide-slate-100">
                                <thead className="bg-slate-900">
                                    <tr>
                                        <th scope="col" className="px-8 py-6 text-left text-xs font-black text-amber-500 uppercase tracking-[0.2em]">User Email</th>
                                        <th scope="col" className="px-8 py-6 text-left text-xs font-black text-amber-500 uppercase tracking-[0.2em]">Service Name</th>
                                        <th scope="col" className="px-8 py-6 text-center text-xs font-black text-amber-500 uppercase tracking-[0.2em]">Status</th>
                                        <th scope="col" className="px-8 py-6 text-center text-xs font-black text-amber-500 uppercase tracking-[0.2em]">Actions</th>
                                    </tr>
                                </thead>
                                <tbody className="bg-white divide-y divide-slate-100">
                                    {requests.map((req) => (
                                        <tr key={req._id} className="hover:bg-slate-50 transition-colors group">
                                            <td className="px-8 py-6 whitespace-nowrap text-sm text-slate-500 font-medium">{req.email}</td>
                                            <td className="px-8 py-6 text-sm text-slate-800 font-bold">{req.serviceTitle}</td>
                                            <td className="px-8 py-6 whitespace-nowrap text-center">
                                                <span className={`px-4 py-1.5 rounded-full text-[10px] font-black uppercase tracking-widest border ${req.status === 'Approved' ? 'bg-green-100 text-green-700 border-green-200' : 'bg-amber-100 text-amber-700 border-amber-200'}`}>
                                                    {req.status || 'Pending'}
                                                </span>
                                            </td>
                                            <td className="px-8 py-6 whitespace-nowrap text-center flex items-center justify-center space-x-3">
                                                {req.status !== 'Approved' && (
                                                    <button 
                                                        onClick={() => handleApprove(req._id)}
                                                        className="bg-green-500/10 text-green-600 hover:bg-green-600 hover:text-white p-3 rounded-2xl transition-all shadow-sm border border-transparent hover:border-green-200"
                                                        title="Approve"
                                                    >
                                                        <i className="fas fa-check"></i>
                                                    </button>
                                                )}
                                                <button 
                                                    onClick={() => handleDelete(req._id)}
                                                    className="bg-red-500/10 text-red-600 hover:bg-red-600 hover:text-white p-3 rounded-2xl transition-all shadow-sm border border-transparent hover:border-red-200"
                                                    title="Delete"
                                                >
                                                    <i className="fas fa-trash-alt"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ManageServiceRequests;
